import { useMutation } from '@apollo/client/react';
import { STAFF_MOVE_CONTENT } from '@staff-app/graphql-client';

export interface MoveContentResult {
  contentId: string;
  contentType: string;
  oldAccountId: string;
  oldOwnerEmail?: string | null;
  newAccountId: string;
  newOwnerEmail?: string | null;
  newPath: string;
  // Power BI only. null = not a Power BI asset. false = the asset moved but its
  // powerBIAssets record (SmallApp microservices Mongo) did NOT follow — it will
  // 403 in the msbi editor until someone finishes the rewrite.
  smallappSynced?: boolean | null;
  smallappMessage?: string | null;
}

export function useMoveContent() {
  return useMutation<
    { staffMoveContent: MoveContentResult },
    { contentId: string; folderPath: string }
  >(STAFF_MOVE_CONTENT);
}
